import { ReactNode } from 'react';
import { useSigninCheck } from 'reactfire';
import { Navigate } from 'react-router-dom';

import { CircularProgress } from '@mui/material';

import { LoaderContainer } from '../styled/App.styled';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { status, data: signinCheckResult } = useSigninCheck();

  if (status === 'loading') {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  if (!signinCheckResult.signedIn) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
